import * as React from 'react';
import {Item as DataItem} from '../data';
import Card from "material-ui/Card/Card";
import CardText from "material-ui/Card/CardText";
import CardMedia from "material-ui/Card/CardMedia";
import l10n = require('diy/util/l10n');
import {ModuleType} from 'diy/module/Modul';
import websiteData = require("diy/util/websiteData");
import AppRegistry from "diy/AppRegistry";
import BlankModuleDragSource = require('diy/module/common/js/dd/BlankModuleDragSource');
import BlankSectionHelper from 'diy/module/common/js/dd/BlankSectionHelper';

let siteadminApi = require<any>('diy/site-admin/main/api');

import $ = require('jquery');

interface ItemProps {
    item: DataItem;
    width: number;
    height: number;
}

export class Item extends React.Component<ItemProps, {}> {
    private cardWrapper: HTMLElement;

    getSrc() {
        let cdnUrl = websiteData.getCdnUrl();
        let baseSection = this.props.item.base;
        let sectionVariant = this.props.item.variant;
        let languageCode = websiteData.getLanguageCode();

        return `${cdnUrl}sections/${baseSection}/public/${sectionVariant}.${languageCode}.jpg`;
    }

    render() {
        let item = this.props.item;
        let thumbHeight = this.props.height;
        let thumbWidth = this.props.width;

        return (
            <div
                className="category-item-card disable-touch-defaults"
                ref={ref => this.cardWrapper = ref}
                onMouseUp={() => this.showTooltip()}
            >
                <Card>
                    <CardMedia>
                        <img alt={item.label} height={thumbHeight} width={thumbWidth} src={this.getSrc()}
                            style={{backgroundColor: "#ccc"}} />
                    </CardMedia>
                    <CardText style={this.getLabelStyles()}>
                        {item.label}
                    </CardText>
                </Card>
            </div>
        );
    }

    componentDidMount() {
        this.setupItemWrapper(this.cardWrapper);
        this.setupDraggable();
    }

    private setupItemWrapper(ref: HTMLElement) {
        let item = this.props.item;
        let draggableAttrs: {[attrName: string]: string} = {
            "data-moduleMinWidth": "400",
            "data-allowedInSidebar": "false",
            "data-moduleType": "local",
            "data-moduleName": ModuleType.SECTION,
            "data-moduleLabel": item.label,
            "data-sectionName": item.base + "/" + item.variant
        };
        for (let attrName in draggableAttrs) {
            if (draggableAttrs.hasOwnProperty(attrName)) {
                ref.setAttribute(attrName, draggableAttrs[attrName]);
            }
        }
    }

    private setupDraggable() {
        let dragHelper = new BlankSectionHelper();
        $(this.cardWrapper).each(function(index, elem) {
            let dragSource = new BlankModuleDragSource($(elem));
            dragSource.setHelper(dragHelper);
            AppRegistry.getModuleDragDrop().addDragSource(dragSource);
        })
        .on('ddstart', function() {
            // hide the site admin bar and window
            siteadminApi.hide();
        })
        .on('ddcancel', function() {
            // Show the section selector again because we cancelled the drop
            siteadminApi.show();
        })
        .on('dddropped', () => {
            //Close the siteadmin window
            siteadminApi.close(false, true);
            //Show the siteadmin bar
            siteadminApi.show();
        });
    }

    private getLabelStyles() {
        return {
            borderTop: '1px solid #ebebeb',
            padding: 0,
            boxSizing: "border-box",
            WebkitBoxSizing: "border-box",
            height: "30px",
            lineHeight: "30px",
            fontFamily: "'Open Sans', sans-serif",
            fontWeight: 600,
            fontSize: "10px",
            color: "rgba(73, 84, 100, 0.8)",
            paddingLeft: "8px"
        };
    }

    private hideTooltip() {
        $(this.cardWrapper).diy_tooltip('destroy');
    }

    private showTooltip() {
        $(window).on(
            'mousedown.sectionSelector scroll.sectionSelector resize.sectionSelector',
            () => {
                this.hideTooltip();
                $(window).off('.sectionSelector');
            }
        );

        $(this.cardWrapper)
            .diy_tooltip({
                anchorOffset: -13,
                zIndex: 100110,
                fadeOutDelay: 400,
                fadeInDelay: 400,
                triggerMode: 'none',
                cls: 'module_selector_tooltip',
                content: !diy.editor.uiPreference.isPointerModeTouch() ?
                    l10n.getString('moduleSelector.moduleTooltip') :
                    l10n.getString('moduleSelector.moduleTooltipMobile')
            })
            .diy_tooltip('show', this.cardWrapper);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/section-selector/components/Item.tsx
 **/